import { Component, OnInit } from '@angular/core';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';

@Component({
  selector: 'accesoDenegado',
  templateUrl: 'accesoDenegado.template.html'
})
export class accesoDenegadoComponent implements OnInit {
  constructor(public waitService: WaitLoadingService) {
  }

  ngOnInit() { this.waitService.cancelWaiting(); }

}
